import { GRID_ROLE, isWixStudio } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Table',
  isConnectGfppEnabled: true,
  compactErrorPanel: false,
  panel: {
    height: 528,
    title: 'Connect_Panel_Title_Table',
    helpId: '41011fe0-f4cc-447a-8632-f9514d7502e7',
  },
  sections: [
    {
      role: GRID_ROLE,
      bindings: [],
      manifest: {
        gfpp: {
          desktop: {
            ...(isWixStudio()
              ? {
                  mainAction1: {
                    actionId: 'manageTable',
                    label: 'Table_Live_Preview_GFPP_Desktop_ManageTableAction',
                  },
                }
              : {}),
            mainAction2: {
              actionId: 'table_live_preview_gfpp_desktop_main_action',
              label: 'Table_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
  ],
  supportsDefaultSelectedDataset: false,
})
